import { render, staticRenderFns } from "./KpiScenep.vue?vue&type=template&id=58c8530c&scoped=true&"
import script from "./KpiScenep.vue?vue&type=script&lang=js&"
export * from "./KpiScenep.vue?vue&type=script&lang=js&"
import style0 from "./KpiScenep.vue?vue&type=style&index=0&id=58c8530c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c8530c",
  null
  
)

export default component.exports